export default [
  {
    fileName: "client/banner_recommend_3.jpg",
    link: "https://upromania.ro/utilizatori/recomanda-si-castiga/",
    category: "Banner",
    action: "Click",
    label: "Afiliat_Recomanda",
  },
];
